module.exports = new __parcel__URL__("filter_afaire.a0076ffb.png").toString();